import { Modal } from '@skyline-platform/alchemy';
import {
  camelToHeader,
  kebabToHeader,
  toCamelCase,
} from '@utils/general';
import PropTypes from 'prop-types';

export const EditModal = ({
  data, FormComponent, title, setTitle, fieldName, trigger,
}) => {
  const formattedFieldName = fieldName.includes('-')
    ? kebabToHeader(fieldName)
    : camelToHeader(fieldName);

  const formattedDataName = fieldName.includes('-')
    ? `${toCamelCase(fieldName.replace(/-/g, ' '))}Data`
    : `${fieldName}Data`;

  return (
    <Modal
      className={`edit-${fieldName}-modal`}
      closeIcon
      header={fieldName !== 'stream'
        ? `Edit ${formattedFieldName}`
        : title
      }
      disableBackdropClick
      trigger={trigger}
      // Prevent key actions from propagating to the outer Action Modal component
      onKeyDown={(event) => event.stopPropagation()}
      slots={{
        content: (handleClose) => (
          <FormComponent
            id={`edit-${fieldName}-modal`}
            handleClose={handleClose}
            {...{
              [fieldName === 'streamProfile'
                ? 'sourceData'
                : formattedDataName]: data,
            }}
            {...(fieldName === 'stream' ? { setTitle: setTitle } : {})}
          />
        ),
      }}
    />
  );
};

EditModal.propTypes = {
  data: PropTypes.object,
  fieldName: PropTypes.string,
  FormComponent: PropTypes.node,
  setTitle: PropTypes.func,
  title: PropTypes.string,
  trigger: PropTypes.node,
};